export const DOTS = [
  { id: 1, scale: 1, inset: '20% auto auto 55%' },
  { id: 2, scale: 0.8, inset: '70% auto auto 85%' },
  { id: 3, scale: 0.6, inset: '90% auto 0 -8%' },
];
